function pills(){
  var pathname = window.location.pathname;
  $('.collection-filter__pills ul li').each(function(){
    var href = $(this).find('a').attr('href');
    var url = new URL(href, window.location.origin);
    var pathnamePills = url.pathname;
    if(pathname == pathnamePills){
      $(this).addClass('active-pill');
    }
  });
};

$(document).ready(function() {
  pills();
});


document.addEventListener('collection:reloaded', function() {
  console.log('Soy el Console.Log de las pildoras');
  pills();
});